module.exports = __webpack_public_path__ + "linea-ecommerce-10.9b3d6789b2aa87ea4f5b.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-ecommerce-10.svg
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-ecommerce-10.svg
// module chunks = styles